import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=966a8cc6&scoped=true&"
import script from "./Public.vue?vue&type=script&lang=js&"
export * from "./Public.vue?vue&type=script&lang=js&"
import style0 from "./Public.vue?vue&type=style&index=0&id=966a8cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966a8cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
